import {
  UIButton,
  UIButtonSize,
  UIButtonVariant,
} from '@perpetua1/oasis-react';
import { Link } from 'gatsby';
import React, { FC } from 'react';
import { segmentTrack } from 'src/utils/analytics';
import { ACTION } from 'src/utils/analytics/constants';

export interface MenuCtaProps {
  menuCta?: {
    title: string;
    buttonLink: string;
    buttonText: string;
    buttonId?: string;
    ctaDescription: {
      raw: string;
    };
  };
}

const MenuCta: FC<MenuCtaProps> = props => {
  const { menuCta } = props;

  return (
    menuCta && (
      <div className="lg:flex items-center justify-center bg-indigo-3-light py-4 hidden cursor-auto">
        <span className="text-indigo-3-dark font-semibold text-3xl">
          {menuCta?.title}
        </span>
        <span className="block font-medium text-gray-3-dark mx-6 text-xl">
          {JSON.parse(menuCta.ctaDescription.raw).content[0].content[0].value}
        </span>
        
        <UIButton
          variant={UIButtonVariant.primary}
          size={UIButtonSize.default}
          id={menuCta?.buttonId}
          text={<Link to={menuCta.buttonLink}>{menuCta.buttonText}</Link>}
          onClick={() => {
            segmentTrack(ACTION.NaviClicked, { label: menuCta.buttonText });
          }}
        />

      </div>
    )
  );
};

export default MenuCta;
